import React from 'react';
import { ctaFinal, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const CtaFinalSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-[#2a2523] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c9a962]/5 rounded-full blur-3xl" />
      </div>
      
      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a962]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a962]/30 to-transparent" />
      
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-6 leading-tight">
          O conflito <span className="text-[#c9a962]">já começou</span>,<br />ou está prestes a começar?
        </h2>
        
        {/* Subtitle */}
        <p className="text-xl text-neutral-400 leading-relaxed mb-10 max-w-2xl mx-auto">
          {ctaFinal.subtitle}
        </p>
        
        {/* CTA Button */}
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-10 py-5 rounded-xl font-semibold text-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-emerald-500/30"
        >
          <MessageCircle className="w-6 h-6" />
          {siteConfig.ctaText}
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
        </a>
        
        {/* Trust badge */}
        <div className="mt-10 flex items-center justify-center gap-6 text-neutral-500">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-emerald-500 rounded-full" />
            <span className="text-sm">Resposta rápida</span>
          </div>
          <div className="w-px h-4 bg-[#3d3632]" />
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-[#c9a962] rounded-full" />
            <span className="text-sm">Sigilo profissional</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaFinalSection;
